import { useContext } from 'react';

import { DiscountCodeActionContext, DiscountCodeValueContext } from './context';

const useDiscountCodeValue = () => {
  const context = useContext(DiscountCodeValueContext);
  if (!context) {
    throw new Error(
      'useDiscountCodeValue must be used within a <DiscountCodeFormContext />',
    );
  }
  return context;
};

const useDiscountCodeAction = () => {
  const context = useContext(DiscountCodeActionContext);
  if (!context) {
    throw new Error(
      'useDiscountCodeAction must be used within a <DiscountCodeFormContext />',
    );
  }
  return context;
};

export { useDiscountCodeAction, useDiscountCodeValue };
